// import React from 'react';
// import './AboutSection.css';

// const highlights = [
//   { number: '8,500', label: 'Sq. Ft. Space' },
//   { number: '7+', label: 'Premium Brands' },
//   { number: '500+', label: 'Happy Members' },
//   { number: '10+', label: 'Expert Trainers' },
// ];

// const features = [
//   {
//     icon: '🏆',
//     title: 'World-Class Equipment',
//     desc: 'Every machine sourced from globally trusted brands like Hammer Strength, Life Fitness, and Hoist.',
//   },
//   {
//     icon: '🎵',
//     title: 'Premium Atmosphere',
//     desc: 'Train to the beat with our Bose Music system installed throughout the entire facility.',
//   },
//   {
//     icon: '💪',
//     title: 'Expert Guidance',
//     desc: 'Our certified trainers are here to guide you every step of the way — from day one to your goals.',
//   },
//   {
//     icon: '🔥',
//     title: 'All Fitness Levels',
//     desc: 'Whether you are just starting out or a seasoned athlete, Gym Arena has everything you need.',
//   },
// ];

// export default function AboutSection() {
//   return (
//     <section id="about" className="about-section">
//       <div className="container">

//         <div className="about-top">
//           <div className="about-text">
//             <p className="section-label">Who We Are</p>
//             <h2 className="section-title">
//               About <span>Gym Arena</span>
//             </h2>
//             <div className="divider" />
//             <p className="about-para">
//               Gym Arena is more than just a gym — it is a community built around
//               the passion for fitness, discipline, and transformation. Spread across
//               a massive 8,500 square feet, our facility is designed to give every
//               member a premium training experience unlike anything else in the city.
//             </p>
//             <p className="about-para">
//               We believe that great equipment, expert coaching, and the right
//               environment are the three pillars of real progress. That is why we have
//               invested in the finest machines from brands like Hammer Strength, Hoist,
//               Life Fitness, FreeMotion, Paramount, and Assault Fitness — paired with
//               a world-class Bose Music system to keep your energy high from the first
//               rep to the last.
//             </p>
//             <p className="about-para">
//               From beginners taking their first steps to competitive athletes pushing
//               their limits, Gym Arena welcomes everyone. Our dedicated team of certified
//               trainers is always on the floor to guide, motivate, and push you toward
//               the best version of yourself.
//             </p>
//           </div>

//           <div className="about-image-block">
//             <div className="about-image-main">
//               <img
//                 src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=700&q=80"
//                 alt="Gym Arena interior"
//               />
//             </div>
//             <div className="about-image-accent">
//               <img
//                 src="https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=400&q=80"
//                 alt="Training at Gym Arena"
//               />
//             </div>
//             <div className="about-badge">
//               <span className="about-badge-num">8,500</span>
//               <span className="about-badge-label">Sq. Ft.</span>
//             </div>
//           </div>
//         </div>

//         <div className="about-stats">
//           {highlights.map((h, i) => (
//             <div className="about-stat-card" key={i}>
//               <span className="about-stat-num">{h.number}</span>
//               <span className="about-stat-label">{h.label}</span>
//             </div>
//           ))}
//         </div>

//         <div className="about-features">
//           {features.map((f, i) => (
//             <div className="about-feature" key={i}>
//               <div className="about-feature-icon">{f.icon}</div>
//               <h4 className="about-feature-title">{f.title}</h4>
//               <p className="about-feature-desc">{f.desc}</p>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }


// import React from 'react';
// import './AboutSection.css';
// import { useGym } from '../context/GymContext';
// import {
//   SlideInLeft,
//   SlideInRight,
//   StaggerChildren,
//   StaggerItem
// } from './AnimateOnScroll';

// export default function AboutSection() {
//   const { data } = useGym();
//   const { gym, about, features } = data;

//   return (
//     <section id="about" className="about-section">
//       <div className="container">

//         {/* 🔥 TOP SECTION */}
//         <div className="about-top">

//           {/* LEFT TEXT */}
//           <SlideInLeft>
//             <div className="about-text">
//               <p className="section-label">Who We Are</p>

//               <h2 className="section-title">
//                 About <span>Gym Arena</span>
//               </h2>

//               <div className="divider" />

//               <p className="about-para">{about.para1}</p>
//               <p className="about-para">{about.para2}</p>
//               <p className="about-para">{about.para3}</p>
//             </div>
//           </SlideInLeft>

//           {/* RIGHT IMAGE */}
//           <SlideInRight delay={0.2}>
//             <div className="about-image-block">

//               <div className="about-image-main">
//                 <img src={about.image1} alt="Gym Arena interior" />
//               </div>

//               <div className="about-image-accent">
//                 <img src={about.image2} alt="Training at Gym Arena" />
//               </div>

//               <div className="about-badge">
//                 <span className="about-badge-num">{gym.area}</span>
//                 <span className="about-badge-label">Sq. Ft.</span>
//               </div>

//             </div>
//           </SlideInRight>

//         </div>

//         {/* 🔥 STATS */}
//         <StaggerChildren className="about-stats">
//           {[
//             { number: gym.area, label: 'Sq. Ft. Space' },
//             { number: gym.totalBrands, label: 'Premium Brands' },
//             { number: gym.totalMembers, label: 'Happy Members' },
//             { number: gym.totalTrainers, label: 'Expert Trainers' },
//           ].map((item, i) => (
//             <StaggerItem key={i}>
//               <div className="about-stat-card">
//                 <span className="about-stat-num">{item.number}</span>
//                 <span className="about-stat-label">{item.label}</span>
//               </div>
//             </StaggerItem>
//           ))}
//         </StaggerChildren>

//         {/* 🔥 FEATURES */}
//         <StaggerChildren className="about-features">
//           {features.map((f, i) => (
//             <StaggerItem key={i}>
//               <div className="about-feature">
//                 <div className="about-feature-icon">{f.icon}</div>
//                 <h4 className="about-feature-title">{f.title}</h4>
//                 <p className="about-feature-desc">{f.desc}</p>
//               </div>
//             </StaggerItem>
//           ))}
//         </StaggerChildren>

//       </div>
//     </section>
//   );
// }




import React from 'react';
import './AboutSection.css';
import { useGym } from '../context/GymContext';
import gym3 from '../assests/gym3.jpeg';
import gym2 from '../assests/gym2.jpeg';
import {
  SlideInLeft,
  SlideInRight,
  StaggerChildren,
  StaggerItem,
  FadeUp
} from './AnimateOnScroll';

export default function AboutSection() {
  const { data } = useGym();
  const { gym, about, features } = data;

  return (
    <section id="about" className="about-section">
      <div className="container">

        {/* 🔥 TOP SECTION */}
        <div className="about-top">

          {/* LEFT TEXT */}
          <SlideInLeft>
            <div className="about-text">

              <FadeUp>
                <p className="section-label">Who We Are</p>
              </FadeUp>

              <FadeUp delay={0.1}>
                <h2 className="section-title">
                  About <span>Gym Arenaa</span>
                </h2>
              </FadeUp>

              <FadeUp delay={0.2}>
                <div className="divider" />
              </FadeUp>

              <FadeUp delay={0.3}>
                <p className="about-para">{about.para1}</p>
              </FadeUp>

              <FadeUp delay={0.4}>
                <p className="about-para">{about.para2}</p>
              </FadeUp>

              <FadeUp delay={0.5}>
                <p className="about-para">{about.para3}</p>
              </FadeUp>

            </div>
          </SlideInLeft>

          {/* RIGHT IMAGE */}
          <SlideInRight delay={0.2}>
            <div className="about-image-block">

              <div className="about-image-main">
                <img src={gym3} alt="Gym Arena interior" />
              </div>

              <div className="about-image-accent">
                <img src={gym2} alt="Training at Gym Arena" />
              </div>

              <div className="about-badge">
                <span className="about-badge-num">{gym.area}</span>
                <span className="about-badge-label">Sq. Ft.</span>
              </div>

            </div>
          </SlideInRight>

        </div>

        {/* 🔥 STATS */}
        <StaggerChildren className="about-stats">
          {[
            { number: gym.area, label: 'Sq. Ft. Space' },
            { number: gym.totalBrands, label: 'Premium Brands' },
            { number: gym.totalMembers, label: 'Happy Members' },
            { number: gym.totalTrainers, label: 'Expert Trainers' },
          ].map((item, i) => (
            <StaggerItem key={i}>
              <div className="about-stat-card">
                <span className="about-stat-num">{item.number}</span>
                <span className="about-stat-label">{item.label}</span>
              </div>
            </StaggerItem>
          ))}
        </StaggerChildren>

        {/* 🔥 FEATURES */}
        <StaggerChildren className="about-features">
          {features.map((f, i) => (
            <StaggerItem key={i}>
              <div className="about-feature">
                <div className="about-feature-icon">{f.icon}</div>
                <h4 className="about-feature-title">{f.title}</h4>
                <p className="about-feature-desc">{f.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerChildren>

      </div>
    </section>
  );
}